var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-form-decorator",
    {
      attrs: {
        id: _vm.id,
        title: _vm.title,
        helpText: _vm.helpText,
        error: _vm.error,
        hasError: _vm.hasError,
        required: _vm.required,
        value: _vm.value,
        locales: _vm.locales,
      },
    },
    [
      _c("div", { ref: "wrapper", staticClass: "d-flex" }, [
        _c(
          "div",
          { staticClass: "ak-form__date-preview-wrapper" },
          [
            _c("span", { staticClass: "ak-icon ak-form__control-icon" }, [
              _vm._v("event"),
            ]),
            _vm._v(" "),
            _c(
              "date-picker",
              _vm._g(
                {
                  class: { "ak-form__control--has-value": true },
                  style: { width: _vm.datePickerWidth },
                  attrs: {
                    type: "date",
                    multiple: true,
                    inline: true,
                    editable: false,
                    disabled: true,
                    placeholder: _vm.placeholder,
                    lang: _vm.$getSetting("defaultLocale"),
                    "input-class":
                      "ak-form__control ak-form__control--width-icon",
                  },
                  model: {
                    value: _vm.dates,
                    callback: function ($$v) {
                      _vm.dates = $$v
                    },
                    expression: "dates",
                  },
                },
                _vm.$currentListeners
              )
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }